export enum NoteState {
    Active = 0,
    Draft = 1,
    WalkInDraft = 2,
    StoredLocal = 3,
    ClinicalSafetyOfficerNote
}
